import React from 'react';
import Styles from './FooterBanner.module.less';
import { classes } from '../../../lib';
import { Button } from '../../Button';

export type FooterBannerProps = {
    title: string;
    text: string;
    color: string;
    cta: {
        buttonText: string;
        url: string;
    };
    afterText?: string;
};

export const FooterBanner = ({
    title,
    text,
    color,
    cta,
    afterText,
}: FooterBannerProps): JSX.Element => {
    return (
        <div
            className={classes(
                Styles.banner,
                Styles[color],
                'horizontal center-middle d-p48 mt-py48 mt-px24'
            )}>
            <div className={classes(Styles.content, 'vertical g32 ')}>
                <h2>{title}</h2>
                <p>{text}</p>
                <div>
                    <Button
                        href={cta.url}
                        size="large"
                        type="primary"
                        shape="round">
                        {cta.buttonText}
                    </Button>
                </div>
                {afterText && <p className={Styles.after}>{afterText}</p>}
            </div>
        </div>
    );
};
